module.exports = __webpack_public_path__ + "img/logo.4842c9da.png";